import CourseContainer from "./CourseContainer";
import { Courses } from "../../schema/courses";

interface ICoursesList {
	data: Courses[];
	isLoading: boolean;
}

export default function CoursesList({ data, isLoading }: ICoursesList) {
	return (
		<div className="w-full flex-1 flex">
			<CourseContainer coursesInfo={data ?? []} isLoading={isLoading} />
		</div>
	);
}
